import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone',
  standalone: true
})
export class PhonePipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) return '';

    const viewValue = value.toString().replace(/\D/g, '');

    if (viewValue.length === 10) {
      const areaCode = viewValue.slice(0, 3);
      const middle = viewValue.slice(3, 6);
      const last = viewValue.slice(6);

      return `(${areaCode}) ${middle}-${last}`;
    }

    return value.toString();
  }
}